{
	"title": "Kenmerken",
	"description": "Waar klanten in de shop op filteren, met vaste waarden, zoals formaat of soort. Een kenmerk kun je als maat aanwijzen: de waarde staat dan vooraan in het maatlabel.",
	"empty": "Er zijn nog geen kenmerken. Maak hieronder het eerste.",
	"sizeBadge": "Maat",
	"values": "Waarden van {{name}}",
	"noValues": "Nog geen waarden.",
	"usageCount_one": "{{count}} keer gebruikt",
	"usageCount_other": "{{count}} keer gebruikt",
	"moveUp": "Omhoog: {{name}}",
	"moveDown": "Omlaag: {{name}}",
	"moved": "{{name}} staat nu op plek {{position}} van {{total}}.",
	"new": {
		"title": "Kenmerk toevoegen",
		"submit": "Toevoegen"
	},
	"edit": {
		"button": "Bewerken: {{name}}",
		"title": "{{name}} bewerken",
		"submit": "Opslaan",
		"cancel": "Annuleren"
	},
	"field": {
		"name": "Naam",
		"namePlaceholder": "Bijvoorbeeld Formaat",
		"isSize": "Dit is de maat",
		"isSizeDescription": "De waarde komt vooraan in het maatlabel (\"46×27 cm · past op …\"). Eén kenmerk kan de maat zijn; zet je het hier aan, dan gaat het bij een ander uit."
	},
	"value": {
		"add": "Waarde toevoegen",
		"addLabel": "Nieuwe waarde voor {{name}}",
		"addPlaceholder": "Nieuwe waarde",
		"rename": "Hernoemen: {{name}}",
		"renameLabel": "Nieuwe naam voor {{name}}",
		"save": "Opslaan",
		"cancel": "Annuleren"
	},
	"delete": {
		"button": "Verwijderen: {{name}}",
		"title": "{{name}} verwijderen?",
		"description": "Het kenmerk en al zijn waarden verdwijnen, ook bij de producten en varianten die ze hebben. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen"
	},
	"deleteValue": {
		"button": "Verwijderen: {{name}}",
		"title": "Waarde {{name}} verwijderen?",
		"description_zero": "Geen product of variant heeft deze waarde. Dit kun je niet ongedaan maken.",
		"description_one": "De waarde verdwijnt, ook bij {{count}} product of variant die hem heeft. Dit kun je niet ongedaan maken.",
		"description_other": "De waarde verdwijnt, ook bij de {{count}} producten en varianten die hem hebben. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen"
	},
	"error": {
		"nameTaken": "Er is al een kenmerk met deze naam.",
		"valueNameTaken": "Dit kenmerk heeft al een waarde met deze naam.",
		"notFound": "Dit kenmerk bestaat niet meer. Laad de pagina opnieuw.",
		"valueNotFound": "Deze waarde bestaat niet meer. Laad de pagina opnieuw.",
		"orderOutdated": "De lijst is intussen veranderd. Hij is opnieuw geladen; verplaats het nog eens."
	},
	"help": {
		"attributes": {
			"title": "Kenmerken",
			"area": "Producten › Kenmerken",
			"short": "Een eigenschap waarop klanten in de shop filteren, met vaste waarden, zoals Formaat: Standaard en XXL. Het verschil met een optie: met een optie kiest de klant een variant, met een kenmerk filtert hij.",
			"terms": ["product:options", "attribute:values", "product:attribute", "product:sizeLabel"]
		},
		"values": {
			"title": "Waarden van een kenmerk",
			"area": "Producten › Kenmerken",
			"short": "De vaste keuzes van een kenmerk, zoals Standaard en XXL. De shop toont ze als filter in deze volgorde; verplaats ze met de pijltjes. Hernoem je een waarde, dan verandert hij bij elk product mee.",
			"warning": "Verwijder je een waarde, dan verdwijnt hij ook bij elk product en elke variant die hem heeft. Naast de waarde zie je hoe vaak dat is.",
			"terms": ["product:attribute"]
		}
	}
}
